var CommonFolderStructureModule = /** @class */ (function () {
    function CommonFolderStructureModule() {
    }
    return CommonFolderStructureModule;
}());
export { CommonFolderStructureModule };
